import React from 'react';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CodeIcon from '@material-ui/icons/Code';
import cyan from '@material-ui/core/colors/cyan';
import lightGreen from '@material-ui/core/colors/lightGreen';
import orange from '@material-ui/core/colors/orange';
import TechnicalSkillChips from '../TechnicalSkillChips';
import { SkillArea } from '../../API';
import TechnicalSkill from '../../models/technical-skills';

const SKILL_AREA_COLORS = {
  [SkillArea.FRONTEND]: cyan[800],
  [SkillArea.BACKEND]: lightGreen[800],
  [SkillArea.MOBILE]: orange[800],
} as Partial<Record<SkillArea, string>>;

const useStyles = makeStyles((theme) => ({
  profileContentSkills: {
    '& h5 > svg': {
      marginRight: theme.spacing(),
      verticalAlign: 'middle',
      fontSize: 'inherit',
    },
  },
  level: {
    float: 'right',
  },
  skillAreaTitle: ({ skillArea }: { skillArea?: SkillArea } = {}) => ({
    color: SKILL_AREA_COLORS[skillArea!],
  }),
}));

export default function SkillsContentCard({ skills }: { skills: TechnicalSkill[] }) {
  const classes = useStyles();
  return (
    <CardContent className={classes.profileContentSkills}>
      <Typography variant="h5" className={classes.skillAreaTitle}>
        <CodeIcon fontSize="large" />
        Main technologies
      </Typography>
      {Boolean(skills.length) && (
        <TechnicalSkillChips skills={skills} showFrequency />
      )}
    </CardContent>
  );
}
